export default "__VITE_ASSET__DE5gXec1__"